import { render, staticRenderFns } from "./AccumulatePoints.vue?vue&type=template&id=6827ccf6&scoped=true"
import script from "./AccumulatePoints.vue?vue&type=script&lang=js"
export * from "./AccumulatePoints.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6827ccf6",
  null
  
)

export default component.exports